export function getGrupo(user) {
  const firstLinkedGroup = user.linked_accounts?.[0]?.permission_groups?.[0]?.name;
  if (firstLinkedGroup) return firstLinkedGroup;
  if (user.groups?.length) return user.groups[0]?.name ?? "-";
  if (user.group?.name) return user.group.name;
  if (user.is_superuser) return "Administrador";
  return "-";
}
